import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router/composables'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import store from '@/store'
import { eventApi, EventPeriod, EventPeriodStats } from '@/enitites/event'
import ProfileEventList from './ProfileEventList.vue'

type ExistedTab = { name: EventPeriod; value: number }


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileEventsTab',
  setup(__props) {

const route = useRoute()

const tabs = ref<EventPeriodStats>({
  now: 0,
  past: 0,
  draft: 0,
  future: 0,
})
const sortAZ = ref(true)
const loading = ref(false)

const userId = computed(() => Number(route.params.id))
const isShowNowTab = computed(() => !!tabs.value.now)
const getUserDB = computed(() => store.getters.getUserDB)
const existedTabs = computed((): ExistedTab[] => {
  if (!getUserDB.value || Number(route.params.id) !== Number(getUserDB.value?.id)) {
    return Object.keys(tabs.value)
      .filter((key) => key !== 'now' && key !== 'draft')
      .map((key) => ({
        name: key as EventPeriod,
        value: tabs.value[key as EventPeriod],
      }))
  }
  return Object.keys(tabs.value)
    .filter((key) => key !== 'now')
    .map((key) => ({
      name: key as EventPeriod,
      value: tabs.value[key as EventPeriod],
    }))
})

const currentTab = ref<EventPeriod | undefined>('past')

const sortEvents = () => {
  if (loading.value) return
  sortAZ.value = !sortAZ.value
}

const setCurrentTab = () => {
  currentTab.value = existedTabs.value.find((tab: ExistedTab) => tab.value > 0)?.name
}

const fetchTabs = async () => {
  const data = await eventApi.getEventsAvailableTabs({ userId: userId.value })
  if (data) tabs.value = data
}

watch(userId, async () => {
  await fetchTabs()
  setCurrentTab()
})

onMounted(async () => {
  await fetchTabs()
  setCurrentTab()
})

return { __sfc: true,route, tabs, sortAZ, loading, userId, isShowNowTab, getUserDB, existedTabs, currentTab, sortEvents, setCurrentTab, fetchTabs, ProfileEventList }
}

})